import { vueAppWithPinia } from "../Common/vueApp";
import ManageOrganizersApp from "./ManageOrganizersApp.vue";

export default vueAppWithPinia(ManageOrganizersApp);
